module.exports = __webpack_public_path__ + "img/hand.1048d7bb.png";